export const availableLanguages = ['de_DE', 'en_GB']
// export const languageMapping = { de: 'de_DE', en: 'en_GB' }
